<template>
  <div>
    <div
      class="instructor-wrap text-start position-relative"
      :style="{
        backgroundImage: `url(//www.animlab.yuntech.edu.tw/upload/2021/instructor/${info.image})`,
        // backgroundImage: `url(${image})`,
      }"
    >
      <div class="instructor-block d-flex align-items-end">
        <div
          class="
            instructor
            h2-style
            mobile-h1
            w-100
            h-100
            d-flex
            align-items-end
          "
        >
          {{ seperatedName[0] }}
          <template v-if="seperatedName.length > 1">
            <br />
            {{ seperatedName[1] }}
          </template>
        </div>
      </div>
    </div>
    <div class="intro small-text mobile-body">{{ info.intro }}</div>
  </div>
</template>

<script>
import linkArrow from '@/assets/img/link_arrow.png';

export default {
  props: {
    info: { type: Object, required: true },
    // image: { type: String },
  },
  data() {
    return {
      linkArrow,
      // bg: this.image,
    };
  },
  computed: {
    seperatedName() {
      return this.info.name.split(' ');
    },
  },
};
</script>

<style lang="stylus" scoped>
.instructor-wrap
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  width: 100%;
  // height: 300px;
  margin-bottom: 32px;

.instructor-block
  width: 100%;
  height: 200px;
  overflow: hidden;
  color: $monoc1;
  padding: 30px;

.intro
  margin-top: 24px;
  margin-bottom: 16px;
  padding-left: 10px;
  padding-right: 10px;
  text-align: justify;
  white-space: normal;
</style>
